import Common from "../modules/common";

const templateNews = {
  init: function () {
    this.events();
  },

  events: function () {
    $(".js-load-more").click(function (e) {
      e.preventDefault();
      $.ajax({
        url: ajaxurl,
        type: "POST",
        dataType: "JSON",
        data: {
          action: "load_posts",
          page: $(".js-load-more").data("current") + 1,
          nonce: $("#nonce").val(),
        },
        beforeSend: function () {
          $(".load-more").addClass("loading");
        },
        success: function (response) {
          $(".news__list").append(response.data.posts);
          $(".load-more").removeClass("loading");
          Common.lazyLoadInstance.update();
          if (response.data.posts) {
            $(".js-load-more").data(
              "current",
              parseInt($(".js-load-more").data("current")) + 1
            );
            if (
              $(".js-load-more").data("current") ===
              $(".js-load-more").data("pages")
            )
              $(".load-more").addClass("hidden");
          }
        },
      });
    });
  },
};

export default templateNews;
